import store from '../store'
import router from './index'



router.beforeEach(async (to, from, next) => {
    window.NProgress.start() // 进度条开始
  
    // 判断是否初始化，若未初始化则执行初始化请求
    const isInit = store.getters.isInit
    if (!isInit) {
        if (to.path === '/500') {
            next()
            return
        } else {
            try {
                await store.dispatch('initialization')
            } catch (e) {
                next('/500')
                return
            }
        }
    }
    next()




})

router.afterEach(() => {
    window.NProgress.done()
})
